import React, { useEffect, useState } from "react"
import { navigate } from "gatsby";
import { useDispatch, useSelector } from "react-redux";

import LoginForm from "../components/LoginForm"

import { Snackbar } from "@material-ui/core";
import Alert from "@material-ui/lab/Alert";
import SEO from '../components/seo';

const Login = (props) => {
  const dispatch = useDispatch();
  const { state } = useSelector(state => {
    return {
      state: state
    }
  })

  const [isSnackOpen, setIsSnackOpen] = useState(state.sessionExpired);

  const handleCloseSnack = () => setIsSnackOpen(false);

  // useEffect(() => {
  //   console.log(state);
  //   if (state && state.isAuthenticated) {
  //     navigate("/dashboard")
  //   }
  // }, [])

  return (
    <div className="container-fluid">
      <SEO title='Login' />
      <div className="row">
        <div className="col-4 offset-4" style={{textAlign:"center",marginTop:"150px"}}>
          <LoginForm 
            setAuthState={(authState) => dispatch({type: 'LOG_IN', payload: { authState }})}
            cancelLogin={() => dispatch({ type: 'LOG_OUT' })}
            setAccount={(accountState) => dispatch({ type: 'SET_ACCOUNT', payload: {accountState} })}
            state={state}
          />
        </div>
      </div>
      <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          open={isSnackOpen} 
          autoHideDuration={4000} 
          onClose={handleCloseSnack}
      >
      <Alert severity="info" onClose={handleCloseSnack}>
          Session expired, please enter your sign in again
      </Alert>
      </Snackbar>
    </div>
  )
}

export default Login